// Platform-defined amendment tags (seeded by backend migration 0255).
//
// TODO(MAI-4463 follow-up): replace with a real /amendment-tags list endpoint
// so admins can manage these without a code deploy. The backend stores them
// as rows; the missing piece is a thin admin list view.

export interface AmendmentTagOption {
  slug: string;
  name: string;
}

export const PLATFORM_AMENDMENT_TAGS: readonly AmendmentTagOption[] = [
  { slug: "scholarship", name: "Scholarship" },
  { slug: "financial_hardship", name: "Financial Hardship" },
  { slug: "pricing_correction", name: "Pricing Correction" },
  { slug: "promotional_discount", name: "Promotional Discount" },
  { slug: "other", name: "Other" },
] as const;
